const ReplyPreview = ({ message }) => {
    return (
        <div
            onClick={() => {
                const el = document.getElementById(`message-${message?.id}`);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "center" });
                    el.classList.add("ring", "rounded", "ring-indigo-200");

                    // Remove highlight after 2s
                    setTimeout(() => {
                        el.classList.remove("ring", "ring-indigo-200");
                    }, 2000);
                }
            }}
            className="border-l-4 border-indigo-400 pl-2 mb-1 bg-indigo-50 rounded-md p-2">
            <div className="flex items-center gap-2 mb-1">
                <img
                    src={message?.sender?.dp ?? "https://placehold.co/400"}
                    alt="reply user"
                    className="w-5 h-5 rounded-full"
                />
                <p className="text-xs font-semibold text-gray-700">
                    {message?.sender?.first_name ?? "Unknown"}
                </p>
            </div>
            <div className="text-xs text-gray-600">
                {(() => {
                    switch (message?.message_type) {
                        case "TXT":
                            return <p>{message?.message}</p>;
                        case "IMG":
                            return (
                                <img
                                    src={message?.media?.file}
                                    alt="reply img"
                                    className="w-16 h-16 rounded object-cover"
                                />
                            );
                        case "IMGS":
                            return (
                                <div className="flex flex-wrap gap-2">
                                    {message?.media?.slice(0, 2)?.map((img, index) => (
                                        <div
                                            key={index}
                                            className={`relative ${message?.media?.length === 1
                                                    ? "w-full"
                                                    : "w-[48%]"
                                                }`}
                                        >
                                            <img
                                                src={img?.file}
                                                alt={`image-${index}`}
                                                className="rounded-lg cursor-pointer object-cover w-full h-40"
                                            />
                                            {index == 1 && message?.media?.length > 2 && (
                                                <div
                                                    className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-xl font-semibold rounded-lg cursor-pointer"
                                                >
                                                    +{message?.media.length - 1} more
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            );
                        case "VID":
                            return (
                                <video className="w-16 h-16 rounded" controls>
                                    <source src={message?.media?.file} type="video/mp4" />
                                </video>
                            );
                        case "AUD":
                            return (
                                <audio controls className="w-32">
                                    <source src={message?.media?.file} type="audio/mpeg" />
                                </audio>
                            );
                        case "PDF":
                            return (
                                <a
                                    href={message?.media?.file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    View PDF
                                </a>
                            );
                        default:
                            return <p className="italic text-gray-400">Unsupported message</p>;
                    }
                })()}
            </div>
        </div>
    )
}

export default ReplyPreview;